import React from 'react';
import { Container } from 'react-bootstrap';
import { FaCheckCircle, FaPhoneAlt } from 'react-icons/fa';

const highlights = [
  'Domestic, commercial and industrial work',
  'Inspection and testing',
  'Solar PV and battery storage',
];

const HeroSection = () => {
  return (
    <section className="hero-section" id="top">
      <Container>
        <div className="hero-grid">
          <div className="hero-copy">
            <p className="section-eyebrow hero-animate hero-animate--eyebrow">
              Electrician in Norwich
            </p>
            <h1 className="hero-animate hero-animate--title">
              Clear, reliable electrical work in Norwich.
            </h1>
            <p className="hero-copy__lead hero-animate hero-animate--lead">
              Moonwood Electrical is based in Spixworth and helps homes,
              businesses and larger premises with electrical installations,
              testing, solar PV and battery storage.
            </p>

            <div className="hero-actions hero-animate hero-animate--actions">
              <a className="site-button" href="tel:+447969087406">
                <FaPhoneAlt aria-hidden="true" />
                <span>Call Ben</span>
              </a>
              <a className="site-button site-button--secondary" href="#contact">
                Request a quote
              </a>
            </div>

            <ul
              className="hero-service-list hero-animate hero-animate--list"
              aria-label="Key services"
            >
              {highlights.map((item, index) => (
                <li key={item} style={{ '--hero-item-delay': `${index * 80}ms` }}>
                  <FaCheckCircle aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="hero-visual hero-animate hero-animate--visual"
            aria-label="Featured project imagery"
          >
            <article className="hero-photo-card hero-photo-card--primary">
              <div className="hero-logo-panel">
                <img
                  src={`${process.env.PUBLIC_URL}/moonwood_electrical_logo.png`}
                  alt="Moonwood Electrical Services logo"
                />
              </div>
              <div className="hero-photo-card__image">
                <img
                  src={`${process.env.PUBLIC_URL}/pool_room.jpg`}
                  alt="Feature lighting inside a vaulted living and games room"
                />
              </div>
              <div className="hero-photo-card__body">
                <p className="hero-photo-card__eyebrow">Recent work</p>
                <h2>Feature lighting with a clean finish</h2>
              </div>
            </article>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;
